import React, { useReducer } from 'react';
import { IAppInitData, IMemberInfo } from './interface';
import { SearchPageContext, onSearchPageReducer } from './context';
import {IndexPage, IIndexPageProps} from './routePages/indexPage';
import './index.scss';
interface IProps extends IIndexPageProps{
    className?: string;
    initData: IAppInitData;
    defaultSelectList?: IMemberInfo[];
}
function DepartmentAndMemberSearch(props: IProps) {
    const { initData, className = '', defaultSelectList = [], ...rest } = props;
    const [state, dispatch] = useReducer(onSearchPageReducer, {
        ...initData,
        selectMemberList: defaultSelectList,
        isLoading: true,
    });

    return (
        <div className={`department-search-app-page ${className}`}>
            <SearchPageContext.Provider value={{ state, dispatch }}>
                <IndexPage {...rest}/>
            </SearchPageContext.Provider>
        </div>
    );
}

export {
    DepartmentAndMemberSearch
};
